import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  public isMobile: boolean = this.checkIsMobile(window.innerWidth);
  public resizing$: Observable<Event>;

  constructor() {
    this.resizing$ = fromEvent(window, 'resize', { passive: true }).pipe(
      debounceTime(40),
      tap((event) => {
        if (event) {
          this.isMobile = this.checkIsMobile(null, event);
        }
      })
    );
  }

  public checkIsMobile(width: number, event?: any) {
    return (width || (<any>event.target).innerWidth) <= 575;
  }
}
